/* 848 STUDIOS layer – vanilla JS, no dependencies */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  const S848 = (window.S848 = window.S848 || {});

  /* ---------------- drawers & modals ---------------- */
  const overlay = () => $('#s848-overlay');
  let openId = null;
  let lastFocus = null;
  /* Drawers/modals live inside section wrappers (main > .shopify-section has its own stacking
     context, the floating header uses transforms). Move them to <body> so they always stack
     above #s848-overlay and position:fixed is relative to the viewport. */
  const portal = (el) => {
    if (!el || !el.isConnected || el.parentElement === document.body) return;
    Array.from(document.body.children).forEach((c) => { if (c !== el && c.id === el.id) c.remove(); });
    document.body.appendChild(el);
  };
  S848.portal = (scope = document) => $$('.s848-drawer, .s848-modal', scope).forEach(portal);
  if (document.readyState !== 'loading') S848.portal(); else document.addEventListener('DOMContentLoaded', () => S848.portal());
  document.addEventListener('shopify:section:load', (e) => S848.portal(e.target));
  S848.open = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    portal(el);
    if (openId && openId !== id) S848.close(openId, true);
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    overlay() && overlay().classList.add('is-open');
    document.body.classList.add('s848-lock');
    openId = id;
    if (!el.contains(document.activeElement)) lastFocus = document.activeElement;
    const f = el.querySelector('[data-s848-autofocus]') || el.querySelector('[data-s848-close]');
    if (f) setTimeout(() => f.focus({ preventScroll: true }), 350);
    el.dispatchEvent(new CustomEvent('s848:open', { bubbles: true }));
  };
  S848.close = (id = openId, keepOverlay) => {
    const el = id && document.getElementById(id);
    if (el) { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); }
    if (!keepOverlay) { overlay() && overlay().classList.remove('is-open'); document.body.classList.remove('s848-lock'); }
    openId = null;
    if (!keepOverlay && lastFocus && document.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (_) {} lastFocus = null; }
  };
  /* v3.7: keep Tab focus inside the open drawer/modal */
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab' || !openId) return;
    const el = document.getElementById(openId);
    if (!el) return;
    const f = $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, summary, [tabindex]:not([tabindex="-1"])', el).filter((n) => n.offsetParent !== null || n === document.activeElement);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (!el.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-s848-open]');
    if (o) { e.preventDefault(); S848.open(o.dataset.s848Open); return; }
    const c = e.target.closest('[data-s848-close]');
    if (c) { e.preventDefault(); S848.close(); return; }
    if (e.target.id === 's848-overlay') S848.close();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { S848.close(); closeMegas(); } });

  /* ---------------- language / country menu ---------------- */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-s848-locale-toggle]');
    $$('[data-s848-locale]').forEach((w) => {
      const btn = $('[data-s848-locale-toggle]', w), box = $('.s848-locale', w);
      const open = t && w.contains(t) ? !box.classList.contains('is-open') : (w.contains(e.target) && box.classList.contains('is-open'));
      box.classList.toggle('is-open', !!open);
      btn && btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') $$('[data-s848-locale] .s848-locale.is-open').forEach((b) => b.classList.remove('is-open')); });

  /* ---------------- account: fall back to the sign-in URL if <shopify-account> is not available ---------------- */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-s848-account-fallback]');
    if (a && !(window.customElements && customElements.get('shopify-account'))) { e.preventDefault(); window.location.href = a.dataset.s848AccountFallback; }
  });

  /* ---------------- header / mega menu ---------------- */
  /* v3.7: mark the header card while a desktop panel is open so it joins the panel as one piece */
  const syncMegaState = () => $$('.s848-header').forEach((h) => h.classList.toggle('is-mega-open', !!h.querySelector('.s848-header__item.is-open .s848-mega')));
  const closeMegas = () => { $$('.s848-header__item.is-open').forEach((i) => i.classList.remove('is-open')); syncMegaState(); };
  const initHeader = () => {
    const desktop = window.matchMedia('(min-width:1025px)');
    $$('.s848-header__item[data-mega]').forEach((item) => {
      let t;
      item.addEventListener('mouseenter', () => { if (!desktop.matches) return; clearTimeout(t); closeMegas(); item.classList.add('is-open'); syncMegaState(); });
      item.addEventListener('mouseleave', () => { if (!desktop.matches) return; t = setTimeout(() => { item.classList.remove('is-open'); syncMegaState(); }, 120); });
      const trigger = item.querySelector('[data-mega-trigger]');
      trigger && trigger.addEventListener('click', (e) => {
        if (!desktop.matches) return;
        if (trigger.tagName === 'BUTTON') { e.preventDefault(); item.classList.toggle('is-open'); syncMegaState(); }
      });
    });
    const wrap = $('[data-s848-header]');
    if (wrap && wrap.dataset.hideOnScroll === 'true') {
      let last = window.scrollY;
      window.addEventListener('scroll', () => {
        const y = window.scrollY;
        wrap.classList.toggle('is-hidden', y > last && y > 200 && !$('.s848-header__item.is-open'));
        last = y;
      }, { passive: true });
    }
  };

  /* ---------------- money ---------------- */
  S848.money = (cents) => {
    const fmt = (window.S848_SETTINGS && S848_SETTINGS.moneyFormat) || '{{amount_with_comma_separator}} €';
    const v = (cents / 100).toFixed(2);
    const [i, d] = v.split('.');
    const comma = i.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + d;
    const dot = i.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + d;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => (k.indexOf('comma') > -1 ? comma : k === 'amount_no_decimals' ? i : dot));
  };

  /* ---------------- cart ---------------- */
  /* v3.13: the cart page section (data-s848-cart-page) is re-rendered together with the drawer */
  /* v3.14: each cart UI is refreshed with ITS OWN section render (the page never takes the drawer's HTML);
     the drawer is only requested when it is on the page (it is not rendered on /cart) */
  const cartSectionList = () => {
    const list = $$('[data-s848-cart-page]').map((el) => el.dataset.s848Section).filter(Boolean);
    if (document.querySelector('[data-s848-section="848-cart-drawer"]') || !list.length) list.unshift('848-cart-drawer');
    return list;
  };
  const cartSections = { join: (sep) => cartSectionList().join(sep) };
  const renderSections = (sections) => {
    if (!sections) return;
    Object.entries(sections).forEach(([id, html]) => {
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-s848-section="' + id + '"]');
      const cur = document.querySelector('[data-s848-section="' + id + '"]');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    });
    initScrollers(document);
    const cd = document.getElementById('s848-cart-drawer');
    if (cd) { initSwatches(cd); if (cd.classList.contains('is-open')) loadCartRecos(); }
  };
  const setCount = (n) => $$('[data-s848-cart-count]').forEach((el) => { el.textContent = n; el.hidden = n === 0 && el.dataset.hideZero === 'true'; });
  S848.refreshCart = async () => {
    const r = await fetch(window.location.pathname + '?sections=' + cartSections.join(','));
    renderSections(await r.json());
    const c = await (await fetch(root + 'cart.js')).json();
    setCount(c.item_count);
    return c;
  };
  S848.addToCart = async (items, opener) => {
    opener && opener.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: cartSections.join(','), sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (data.status) { alert(data.description || data.message); return; }
      renderSections(data.sections);
      const c = await (await fetch(root + 'cart.js')).json();
      setCount(c.item_count);
      if (!document.querySelector('[data-s848-cart-page]')) S848.open('s848-cart-drawer');
    } finally { opener && opener.removeAttribute('aria-busy'); }
  };
  S848.changeLine = async (key, quantity) => {
    const page = document.querySelector('.s848-cartp');
    page && page.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(root + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: cartSections.join(','), sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (data.status && data.description) { alert(data.description); }
      if (data.sections) renderSections(data.sections); else await S848.refreshCart();
      if (typeof data.item_count === 'number') setCount(data.item_count);
    } catch (_) { window.location.reload(); }
    finally { const pg = document.querySelector('.s848-cartp'); pg && pg.removeAttribute('aria-busy'); }
  };
  /* cart page: typed quantities + order note (no-JS fallback = the form posts to /cart) */
  document.addEventListener('change', (e) => {
    const inp = e.target.closest('[data-s848-line-input]');
    if (inp) { const q = Math.max(0, parseInt(inp.value, 10) || 0); S848.changeLine(inp.dataset.key, q); return; }
    const note = e.target.closest('[data-s848-cart-note]');
    if (note) fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: note.value }) });
  });
  document.addEventListener('keydown', (e) => {
    const inp = e.target.closest && e.target.closest('[data-s848-line-input]');
    if (inp && e.key === 'Enter') { e.preventDefault(); inp.blur(); }
  });
  document.addEventListener('click', (e) => {
    const plus = e.target.closest('[data-s848-open-sizes]');
    if (plus) {
      e.preventDefault();
      e.stopPropagation();
      const card = plus.closest('.s848-card');
      if (!card) return;
      const style = (window.S848_SETTINGS && window.S848_SETTINGS.quickAddStyle) || '';
      const isDesktop = window.matchMedia('(min-width: 1025px)').matches;
      // Escritorio: siempre caja. Móvil: según ajuste.
      if (!isDesktop && (style === 'sheet' || card.classList.contains('s848-card--sheet'))) {
        openSizeSheet(card);
        return;
      }
      // Caja (barra) en escritorio siempre, y en móvil cuando el ajuste es inline
      const wasOpen = card.classList.contains('is-size-open');
      document.querySelectorAll('.s848-card.is-size-open').forEach((c) => c.classList.remove('is-size-open'));
      if (!wasOpen) card.classList.add('is-size-open');
      return;
    }
    const q = e.target.closest('[data-s848-line-qty]');
    if (q) { e.preventDefault(); const ln = q.closest('.s848-cartd-line'); ln && ln.setAttribute('aria-busy', 'true'); S848.changeLine(q.dataset.key, parseInt(q.dataset.s848LineQty, 10)); return; }
    const add = e.target.closest('[data-s848-quick-add]');
    if (add) {
      e.preventDefault();
      S848.addToCart([{ id: parseInt(add.dataset.s848QuickAdd, 10), quantity: 1 }], add);
      const card = add.closest('.s848-card');
      if (card) card.classList.remove('is-size-open');
      const sheet = document.getElementById('s848-size-sheet');
      if (sheet && sheet.classList.contains('is-open')) S848.close('s848-size-sheet');
      return;
    }
    if (!e.target.closest('.s848-card__quick') && !e.target.closest('.s848-size-sheet')) {
      document.querySelectorAll('.s848-card.is-size-open').forEach((c) => c.classList.remove('is-size-open'));
    }
  });

  const ensureSizeSheet = () => {
    let el = document.getElementById('s848-size-sheet');
    if (el) return el;
    el = document.createElement('div');
    el.id = 's848-size-sheet';
    el.className = 's848-size-sheet';
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-label', 'Seleccionar talla');
    el.innerHTML = '<div class="s848-size-sheet__panel"><div class="s848-size-sheet__handle" aria-hidden="true"></div><div class="s848-size-sheet__list"></div></div>';
    document.body.appendChild(el);
    return el;
  };
  const openSizeSheet = (card) => {
    const sizesWrap = card.querySelector('.s848-card__quick-sizes');
    if (!sizesWrap) return;
    const sheet = ensureSizeSheet();
    const list = sheet.querySelector('.s848-size-sheet__list');
    list.innerHTML = '';
    sizesWrap.querySelectorAll('button').forEach((btn) => {
      const clone = btn.cloneNode(true);
      clone.classList.add('s848-size-sheet__btn');
      list.appendChild(clone);
    });
    // Forzar apertura (por si S848.open no la mueve)
    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');
    const ov = document.getElementById('s848-overlay');
    if (ov) ov.classList.add('is-open');
    document.body.classList.add('s848-lock');
    if (typeof S848 !== 'undefined' && S848.open) {
      try { S848.open('s848-size-sheet'); } catch (_) {}
    }
  };

  /* ---------------- product form ---------------- */
  /* swatches without a known colour: CSS colour name if valid, otherwise the variant image */
  const initSwatches = (scope = document) => {
    $$('[data-s848-swatch-name]', scope).forEach((el) => {
      const n = el.dataset.s848SwatchName.replace(/\s+/g, '');
      if (n && window.CSS && CSS.supports('color', n)) el.style.background = n;
      else if (el.dataset.s848SwatchImg) el.style.background = 'url(' + el.dataset.s848SwatchImg + ') center / cover';
      else el.classList.add('is-unknown');
      el.removeAttribute('data-s848-swatch-name');
    });
  };
  const initProductForms = (scope = document) => {
    initSwatches(scope);
    $$('[data-s848-product-form]', scope).forEach((form) => {
      if (form.dataset.ready) return; form.dataset.ready = '1';
      const json = form.querySelector('script[type="application/json"][data-variants]');
      const variants = json ? JSON.parse(json.textContent) : [];
      const idInput = form.querySelector('input[name="id"]');
      const btn = form.querySelector('[data-s848-atc]');
      const priceEl = document.querySelector('[data-s848-price="' + form.dataset.productId + '"]');
      const update = () => {
        const opts = $$('[data-option-index]', form).map((g) => { const c = g.querySelector('input:checked'); return c ? c.value : null; });
        const v = variants.find((v) => v.options.every((o, i) => opts[i] == null || opts[i] === o));
        if (!v) return;
        idInput.value = v.id;
        const complete = opts.every((o) => o != null);
        if (btn) {
          btn.disabled = !v.available && complete;
          btn.querySelector('span').textContent = !v.available && complete ? btn.dataset.soldOut : complete ? btn.dataset.add : btn.dataset.select;
        }
        if (priceEl) {
          const cmp = v.compare_at_price && v.compare_at_price > v.price;
          priceEl.innerHTML = cmp ? '<span class="is-sale">' + S848.money(v.price) + '</span><s>' + S848.money(v.compare_at_price) + '</s>' : '<span>' + S848.money(v.price) + '</span>';
        }
        $$('[data-option-index]', form).forEach((g) => { const c = g.querySelector('input:checked'); const n = g.querySelector('[data-s848-selected-name]'); if (c && n) n.textContent = c.value; });
        // mark sold-out sizes based on current selection
        $$('.s848-sizes label', form).forEach((lab) => lab.classList.remove('is-soldout'));
        const sizeGroup = form.querySelector('.s848-sizes');
        if (sizeGroup) {
          const sizeIndex = parseInt(sizeGroup.closest('[data-option-index]').dataset.optionIndex, 10);
          $$('input', sizeGroup).forEach((inp) => {
            const testOpts = opts.slice();
            testOpts[sizeIndex] = inp.value;
            const available = variants.some((v) => v.available && v.options.every((o, i) => testOpts[i] == null || testOpts[i] === o));
            if (!available) inp.closest('label').classList.add('is-soldout');
          });
        }
        if (form.dataset.mediaSwitch !== 'false' && v.featured_media && v.featured_media.id && form.dataset.lastMedia !== String(v.featured_media.id)) {
          form.dataset.lastMedia = String(v.featured_media.id);
          const slide = document.querySelector('.s848-pdp__slide[data-media-id="' + v.featured_media.id + '"]');
          const track = slide && slide.parentElement;
          if (slide && track) {
            if (track.scrollWidth > track.clientWidth + 4) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
            else if (track.firstElementChild !== slide) track.prepend(slide);
          }
        }
        if (complete && form.dataset.updateUrl === 'true') { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
      };
      form.addEventListener('change', update);
      // sold-out marking now handled inside update()
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const opts = $$('[data-option-index]', form);
        if (opts.some((g) => !g.querySelector('input:checked'))) { opts[0].scrollIntoView({ block: 'center', behavior: 'smooth' }); opts.forEach((g) => g.classList.add('needs-choice')); return; }
        S848.addToCart([{ id: parseInt(idInput.value, 10), quantity: 1 }], btn);
      });
      update();
    });
  };

  /* ---------------- PDP gallery ---------------- */
  const initGallery = () => {
    $$('[data-s848-gallery]').forEach((g) => {
      const track = g.querySelector('.s848-pdp__gallery');
      if (!track) return;
      const thumbs = $$('.s848-pdp__thumbs button', g);
      const mthumbs = $$('.s848-pdp__mthumbs button', g);
      const mstrip = g.querySelector('.s848-pdp__mthumbs');
      const dots = $$('.s848-pdp__dots span', g);
      // slides can be re-ordered (variant image moved first), so thumbs point to slides by media id
      const slideFor = (b, i) => (b.dataset.mediaId && track.querySelector('.s848-pdp__slide[data-media-id="' + b.dataset.mediaId + '"]')) || track.children[i];
      const desk = () => window.matchMedia('(min-width:1025px)').matches;
      const go = (s) => {
        if (!s) return;
        if (desk()) window.scrollTo({ top: s.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
        else track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      };
      thumbs.forEach((b, i) => b.addEventListener('click', () => go(slideFor(b, i))));
      mthumbs.forEach((b, i) => b.addEventListener('click', () => go(slideFor(b, i))));
      const mark = (list, id, i) => {
        let hit = null;
        list.forEach((t, j) => { const on = id ? t.dataset.mediaId === id : j === i; t.classList.toggle('is-active', on); if (on) hit = t; });
        return hit;
      };
      const io = new IntersectionObserver((ents) => ents.forEach((en) => {
        if (!en.isIntersecting) return;
        const i = Array.prototype.indexOf.call(track.children, en.target);
        const id = en.target.dataset.mediaId || '';
        mark(thumbs, id, i);
        const mt = mark(mthumbs, id, i);
        dots.forEach((t, j) => t.classList.toggle('is-active', j === i));
        if (mt && mstrip && mstrip.scrollWidth > mstrip.clientWidth + 2) {
          const left = mt.offsetLeft - (mstrip.clientWidth - mt.offsetWidth) / 2;
          mstrip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        }
      }), { threshold: 0.55 });
      Array.from(track.children).forEach((c) => io.observe(c));
      // mobile: video slides have their own (taller) box -> gallery height follows the slide being viewed, interpolated while swiping
      if (track.querySelector('.s848-pdp__slide--video')) {
        track.classList.add('has-video');
        /* v3.63: the height is only changed once the swipe has settled (scrollend / debounce), never during the
           gesture. Resizing a scroll-snap container mid-swipe makes the browser re-snap on every frame, so swipes
           to/from video slides ran much faster than image->image swipes (iPhone). */
        let settleT = 0, touching = false;
        const fit = () => {
          const slides = Array.from(track.children);
          if (desk() || !slides.length) { track.style.height = ''; return; }
          const w = slides[0].offsetWidth || 1;
          const i = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w)));
          const h = slides[i].offsetHeight;
          if (h && track.style.height !== h + 'px') track.style.height = h + 'px';
        };
        const settle = () => { clearTimeout(settleT); if (touching) return; track.classList.remove('is-touching'); fit(); };
        track.addEventListener('scroll', () => { clearTimeout(settleT); settleT = setTimeout(settle, 90); }, { passive: true });
        if ('onscrollend' in window) track.addEventListener('scrollend', settle, { passive: true });
        const freeze = () => {
          // stop a running height transition at its current value so nothing resizes during the new gesture
          if (desk()) return;
          clearTimeout(settleT);
          touching = true;
          track.classList.add('is-touching');
          track.style.height = track.getBoundingClientRect().height + 'px';
        };
        track.addEventListener('touchstart', freeze, { passive: true });
        const release = () => { touching = false; clearTimeout(settleT); settleT = setTimeout(settle, 250); };
        track.addEventListener('touchend', release, { passive: true });
        track.addEventListener('touchcancel', release, { passive: true });
        window.addEventListener('resize', () => { clearTimeout(settleT); settleT = setTimeout(settle, 100); });
        track.classList.add('is-touching');
        fit();
        requestAnimationFrame(() => track.classList.remove('is-touching'));
      }
    });
  };

  /* ---------------- toggles (Hombre/Mujer etc.) ---------------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-s848-toggle]');
    if (!b) return;
    const sec = b.closest('[data-s848-toggle-root]');
    $$('[data-s848-toggle]', sec).forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
    $$('[data-s848-panel]', sec).forEach((p) => { p.hidden = p.dataset.s848Panel !== b.dataset.s848Toggle; });
    const link = sec.querySelector('[data-s848-toggle-link]');
    if (link && b.dataset.link) link.href = b.dataset.link;
  });

  /* ---------------- drag-to-scroll ---------------- */
  const initScrollers = (scope = document) => {
    $$('.s848-hscroll', scope).forEach((el) => {
      if (el.dataset.drag) return; el.dataset.drag = '1';
      let down = false, sx = 0, sl = 0, moved = false;
      el.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.pageX; sl = el.scrollLeft; });
      window.addEventListener('pointerup', () => { if (!down) return; down = false; el.classList.remove('is-dragging'); });
      el.addEventListener('pointermove', (e) => { if (!down) return; const dx = e.pageX - sx; if (Math.abs(dx) > 5) { moved = true; el.classList.add('is-dragging'); } el.scrollLeft = sl - dx; });
      el.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      if (el.dataset.loop === 'true' && !el.dataset.cloned) {
        el.dataset.cloned = '1';
        const kids = Array.from(el.children);
        kids.forEach((k) => { const c = k.cloneNode(true); c.setAttribute('aria-hidden', 'true'); el.appendChild(c); });
        el.addEventListener('scroll', () => { const half = el.scrollWidth / 2; if (el.scrollLeft >= half) el.scrollLeft -= half; }, { passive: true });
      }
    });
  };

  /* ---------------- autoplay slider (stores) ---------------- */
  const initSliders = () => {
    $$('[data-s848-slider]').forEach((s) => {
      const track = s.querySelector('.s848-slider__track');
      const n = track.children.length;
      const dots = $$('.s848-slider__dots button', s);
      let i = 0;
      const go = (k) => { i = (k + n) % n; track.style.transform = 'translateX(' + -100 * i + '%)'; dots.forEach((d, j) => d.classList.toggle('is-active', j === i)); };
      dots.forEach((d, j) => d.addEventListener('click', () => { go(j); restart(); }));
      let timer;
      const ms = parseInt(s.dataset.autoplay || '0', 10);
      const restart = () => { clearInterval(timer); if (ms > 0 && n > 1) timer = setInterval(() => go(i + 1), ms); };
      let x0 = null;
      s.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      s.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); restart(); } x0 = null; });
      go(0); restart();
    });
  };

  /* ---------------- collection: columns, image mode, filters ---------------- */
  const initCollection = () => {
    $$('[data-s848-cols]').forEach((b) => b.addEventListener('click', () => {
      const grid = document.getElementById(b.dataset.target);
      if (!grid) return;
      const bp = window.matchMedia('(min-width:1025px)').matches ? 'd' : 'm';
      grid.style.setProperty(bp === 'd' ? '--cols-d' : '--cols-m', b.dataset.s848Cols);
      if (bp === 'd') grid.style.setProperty('--cols-t', b.dataset.s848Cols);
      $$('[data-s848-cols]', b.parentElement).forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
      try { localStorage.setItem('s848-cols-' + bp, b.dataset.s848Cols); } catch (_) {}
    }));
    const bp = window.matchMedia('(min-width:1025px)').matches ? 'd' : 'm';
    let saved = null; try { saved = localStorage.getItem('s848-cols-' + bp); } catch (_) {}
    if (saved) { const b = $$('[data-s848-cols="' + saved + '"]').find((x) => x.offsetParent !== null); b && b.click(); }
    $$('[data-s848-image-mode]').forEach((b) => b.addEventListener('click', () => {
      const grid = document.getElementById(b.dataset.target);
      const mode = b.dataset.s848ImageMode === 'model' ? 'model' : 'product';
      $$('[data-s848-image-mode]', b.parentElement).forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
      grid && (grid.dataset.imageMode = mode);
    }));
    const bar = $('[data-s848-toolbar]');
    if (bar) {
      let lastY = window.scrollY;
      window.addEventListener('scroll', () => {
        const y = window.scrollY;
        if (Math.abs(y - lastY) < 4) return;
        bar.classList.toggle('is-hidden', y > lastY && y > 200);
        lastY = y;
      }, { passive: true });
    }
    $$('[data-s848-filters]').forEach((form) => {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const fd = new FormData(form);
        const params = new URLSearchParams();
        for (const [k, v] of fd.entries()) {
          if (v === '') continue;
          if (k === 'sort_by' && v === form.dataset.defaultSort && !new URLSearchParams(location.search).has('sort_by')) continue; // keep the collection's own default
          params.append(k, v);
        }
        window.location.search = params.toString();
      });
    });
  };

  /* ---------------- load more (collection / search pagination) ---------------- */
  document.addEventListener('click', async (e) => {
    const a = e.target.closest('[data-s848-load-more]');
    if (!a) return;
    e.preventDefault();
    a.setAttribute('aria-busy', 'true');
    const html = await (await fetch(a.href)).text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const id = a.dataset.s848LoadMore;
    const fresh = doc.getElementById(id);
    const grid = document.getElementById(id);
    if (fresh && grid) Array.from(fresh.children).forEach((c) => grid.appendChild(c));
    const next = doc.querySelector('[data-s848-load-more="' + id + '"]');
    if (next) { a.href = next.href; a.removeAttribute('aria-busy'); } else a.parentElement.remove();
    syncHearts();
  });

  /* ---------------- wishlist & recently viewed (localStorage) ---------------- */
  const store = {
    get: (k) => { try { return JSON.parse(localStorage.getItem(k) || '[]'); } catch (_) { return []; } },
    set: (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch (_) {} }
  };
  const wishOn = !(window.S848_SETTINGS && window.S848_SETTINGS.wishlist === false);
  /* Products given by handle (text settings) that Liquid could not resolve: fetch them with the alternate views. */
  const hydrateHandles = (scope = document) => {
    const one = (el, h, view) => fetch(root + 'products/' + encodeURIComponent(h) + '?view=' + view)
      .then((r) => (r.ok ? r.text() : ''))
      .then((html) => {
        if (!html.trim()) { el.remove(); return; }
        const t = document.createElement('template'); t.innerHTML = html.trim();
        const frag = t.content; initSwatches(frag); el.replaceWith(frag);
        if (wishOn) syncHearts();
      }).catch(() => el.remove());
    $$('[data-s848-card-handle]', scope).forEach((el) => one(el, el.dataset.s848CardHandle, '848-card'));
    $$('[data-s848-stl-handle]', scope).forEach((el) => one(el, el.dataset.s848StlHandle, '848-stl'));
  };
  const syncHearts = () => {
    if (!wishOn) return;
    const list = store.get('s848-wishlist');
    $$('[data-s848-wish]').forEach((b) => { const on = list.includes(b.dataset.s848Wish); b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    $$('[data-s848-wish-count]').forEach((el) => { el.textContent = list.length; el.hidden = list.length === 0; });
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-s848-wish]');
    if (!b) return;
    e.preventDefault();
    let list = store.get('s848-wishlist');
    const h = b.dataset.s848Wish;
    list = list.includes(h) ? list.filter((x) => x !== h) : [h].concat(list);
    store.set('s848-wishlist', list);
    syncHearts();
  });
  /* v3.54 cart drawer: "Completa el look" / "Recomendados" from Shopify product recommendations (helper section
     848-cart-recos). Collection products rendered by Liquid stay as the fallback when there are no recommendations. */
  const recoCache = new Map();
  const loadCartRecos = async () => {
    const box = document.querySelector('#s848-cart-drawer [data-s848-cart-recos]');
    if (!box || box.dataset.loaded) return;
    box.dataset.loaded = '1';
    const intent = box.dataset.source;
    if (intent !== 'complementary' && intent !== 'related') return;
    let pid = box.dataset.productId;
    if (!pid) {
      const recent = store.get('s848-recent')[0];
      if (!recent) return;
      try { const pr = await (await fetch(root + 'products/' + encodeURIComponent(recent) + '.js')).json(); pid = pr && pr.id; } catch (_) { return; }
      if (!pid) return;
    }
    const limit = parseInt(box.dataset.limit || '6', 10);
    const excl = (box.dataset.exclude || '').split(',').filter(Boolean);
    const url = (box.dataset.url || root + 'recommendations/products') + '?section_id=848-cart-recos&product_id=' + encodeURIComponent(pid) + '&limit=' + Math.min(10, limit + excl.length) + '&intent=' + intent;
    let html = recoCache.get(url);
    if (html === undefined) {
      try { const r = await fetch(url); html = r.ok ? await r.text() : ''; } catch (_) { html = ''; }
      recoCache.set(url, html);
    }
    if (!html || !box.isConnected) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const hideSold = box.dataset.hideSoldOut === 'true';
    const items = $$('[data-s848-reco-items] > *', doc)
      .filter((n) => !excl.includes(n.dataset.handle) && !(hideSold && n.dataset.available === 'false'))
      .slice(0, limit);
    const track = box.querySelector('[data-s848-cart-recos-track]');
    if (!items.length || !track) return;
    track.innerHTML = '';
    items.forEach((n) => track.appendChild(document.importNode(n, true)));
    box.hidden = false;
    initSwatches(track); initScrollers(box); syncHearts();
  };
  document.addEventListener('s848:open', (e) => { if (e.target.id === 's848-cart-drawer') loadCartRecos(); });
  document.addEventListener('shopify:section:load', () => { const cd = document.getElementById('s848-cart-drawer'); if (cd && cd.classList.contains('is-open')) loadCartRecos(); });
  /* v3.61 PDP block «Completa el look»: no products chosen -> Shopify complementary recommendations
     (helper section 848-pdp-look-recos). The block stays hidden when there is nothing to show. */
  const loadPdpLook = (scope = document) => {
    $$('[data-s848-pdlook-recos]', scope).forEach(async (box) => {
      if (box.dataset.loaded) return;
      box.dataset.loaded = '1';
      const pid = box.dataset.productId;
      if (!pid) return;
      const limit = parseInt(box.dataset.limit || '3', 10);
      const cur = document.querySelector('[data-s848-current-product]');
      const self = cur ? cur.dataset.s848CurrentProduct : '';
      const intent = box.dataset.intent === 'related' ? 'related' : 'complementary';
      const fetchItems = async (it) => {
        const url = (box.dataset.url || root + 'recommendations/products') + '?section_id=848-pdp-look-recos&product_id=' + encodeURIComponent(pid) + '&limit=' + Math.min(10, limit + 1) + '&intent=' + it;
        let html = recoCache.get(url);
        if (html === undefined) {
          try { const r = await fetch(url); html = r.ok ? await r.text() : ''; } catch (_) { html = ''; }
          recoCache.set(url, html);
        }
        if (!html) return [];
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return $$('[data-s848-reco-items] > *', doc).filter((n) => n.dataset.handle !== self && n.dataset.handle !== String(pid)).slice(0, limit);
      };
      let items = await fetchItems(intent);
      if (!items.length && intent === 'complementary' && box.dataset.fallback !== 'false') items = await fetchItems('related');
      const track = box.querySelector('[data-s848-pdlook-track]');
      if (!items.length || !track || !box.isConnected) return;
      track.innerHTML = '';
      items.forEach((n) => track.appendChild(document.importNode(n, true)));
      box.hidden = false;
      initScrollers(box);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => loadPdpLook()); else loadPdpLook();
  document.addEventListener('shopify:section:load', (e) => { loadPdpLook(e.target); initScrollers(e.target); });
  document.addEventListener('shopify:block:select', (e) => loadPdpLook(e.target.closest ? (e.target.closest('.shopify-section') || document) : document));
  const renderHandles = async (container, handles) => {
    if (!container) return;
    const htmls = await Promise.all(handles.map((h) => fetch(root + 'products/' + h + '?view=848-card').then((r) => (r.ok ? r.text() : '')).catch(() => '')));
    container.innerHTML = htmls.join('');
    syncHearts();
  };
  document.addEventListener('s848:open', (e) => {
    if (e.target.id !== 's848-wishlist-drawer') return;
    const list = store.get('s848-wishlist');
    const grid = $('[data-s848-wishlist-grid]');
    const empty = $('[data-s848-wishlist-empty]');
    if (empty) empty.hidden = list.length > 0;
    renderHandles(grid, list);
  });
  const initRecent = () => {
    const cur = document.querySelector('[data-s848-current-product]');
    let list = store.get('s848-recent');
    if (cur) { const h = cur.dataset.s848CurrentProduct; list = [h].concat(list.filter((x) => x !== h)).slice(0, 13); store.set('s848-recent', list); }
    $$('[data-s848-recent]').forEach((wrap) => {
      const excl = cur ? cur.dataset.s848CurrentProduct : null;
      const handles = list.filter((x) => x !== excl).slice(0, parseInt(wrap.dataset.limit || '12', 10));
      if (!handles.length) { wrap.closest('section, .shopify-section').hidden = true; return; }
      renderHandles(wrap.querySelector('[data-s848-recent-grid]'), handles);
    });
  };

  /* ---------------- predictive search ---------------- */
  const initSearch = () => {
    const input = $('[data-s848-search-input]');
    const results = $('[data-s848-search-results]');
    const def = $('[data-s848-search-default]');
    if (!input || !results) return;
    let t, ctrl;
    input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (!q) { results.innerHTML = ''; results.hidden = true; def && (def.hidden = false); return; }
      t = setTimeout(async () => {
        ctrl && ctrl.abort(); ctrl = new AbortController();
        try {
          const types = (window.S848_SETTINGS && window.S848_SETTINGS.searchTypes) || 'product';
          const r = await fetch(root + 'search/suggest?q=' + encodeURIComponent(q) + '&resources[type]=' + encodeURIComponent(types) + '&resources[limit]=8&resources[limit_scope]=each&section_id=848-predictive-search', { signal: ctrl.signal });
          const html = await r.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('[data-s848-predictive]');
          results.innerHTML = inner ? inner.innerHTML : '';
          results.hidden = false; def && (def.hidden = true);
          syncHearts();
        } catch (_) {}
      }, 250);
    });
  };

  /* ---------------- size guide: units, measures, drawing, hover (v3.70) ---------------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-s848-unit]');
    if (!b) return;
    const box = b.closest('[data-s848-units]');
    $$('[data-s848-unit]', box).forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
    $$('[data-unit-table]', box).forEach((tb) => { tb.hidden = tb.dataset.unitTable !== b.dataset.s848Unit; });
    s848SgConvert(box, b.dataset.s848Unit);
  });
  /* v3.69 – dynamic garment drawing: show only the measures the table has, with matching letters */
  const SGD_KEYS = [
    ['sleeve', ['manga', 'sleeve', 'manche', 'armel', 'arm length', 'armlange', 'manica', 'maniga']],
    ['shoulder', ['hombro', 'shoulder', 'epaule', 'schulter', 'spalla', 'ombro', 'espatlla', 'muscle']],
    ['rise', ['tiro', 'rise', 'montant', 'fourche', 'leibhohe', 'leibhoehe', 'altezza cavallo', 'gancho', 'entrecuix']],
    ['inseam', ['entrepierna', 'inseam', 'inside leg', 'inner leg', 'entrejambe', 'schrittlange', 'schrittlaenge', 'innenbein', 'cavallo', 'entreperna', 'interior pierna', 'interior de pierna']],
    ['thigh', ['muslo', 'thigh', 'cuisse', 'oberschenkel', 'coscia', 'coxa', 'cuixa']],
    ['hem', ['bajo', 'leg opening', 'opening', 'hem', 'ourlet', 'bas de jambe', 'saum', 'beinoffnung', 'beinweite', 'fondo', 'orlo', 'bainha', 'barra', 'abertura', 'baix', 'boca']],
    ['waist', ['cintura', 'waist', 'taille', 'bund', 'vita', 'cos ', 'cinta']],
    ['hip', ['cadera', 'hip', 'hanche', 'hufte', 'huefte', 'fianchi', 'fianco', 'quadril', 'anca', 'maluc']],
    ['chest', ['pecho', 'chest', 'poitrine', 'brust', 'petto', 'peito', 'pit', 'axila', 'ancho', 'width', 'contorno', 'largeur', 'breite', 'larghezza', 'largura', 'amplada', 'ample', 'busto', 'bust']],
    ['length', ['largo', 'length', 'longueur', 'lange', 'laenge', 'lunghezza', 'comprimento', 'llarg', 'longitud', 'long', 'total', 'alto', 'hohe', 'altura']]
  ];
  const SGD_TXT = {
    es: { chest: 'Mide de costura lateral a costura lateral por la parte más ancha del pecho, justo debajo de las axilas.', length: { top: 'Mide desde el punto más alto del hombro, junto al cuello, hasta el bajo de la prenda.', bottom: 'Mide por el lateral desde la parte superior de la cintura hasta el bajo.' }, sleeve: 'Mide desde la costura del hombro hasta el final del puño.', shoulder: 'Mide de costura de hombro a costura de hombro por la espalda.', hem: { top: 'Mide el ancho del bajo de lado a lado.', bottom: 'Mide el ancho del bajo de la pierna de lado a lado.' }, waist: 'Mide el ancho de la cintura de lado a lado, con la prenda en plano.', hip: 'Mide el ancho de la cadera de lado a lado por la parte más ancha.', inseam: 'Mide desde la entrepierna hasta el bajo por la costura interior.', rise: 'Mide desde la entrepierna hasta la parte superior de la cintura.', thigh: 'Mide el ancho del muslo de lado a lado, justo debajo de la entrepierna.' },
    en: { chest: 'Measure from side seam to side seam across the fullest part of the chest, just below the armpits.', length: { top: 'Measure from the highest point of the shoulder, next to the neck, to the hem.', bottom: 'Measure along the side from the top of the waistband to the hem.' }, sleeve: 'Measure from the shoulder seam to the end of the cuff.', shoulder: 'Measure from shoulder seam to shoulder seam across the back.', hem: { top: 'Measure the hem width from side to side.', bottom: 'Measure the leg opening from side to side.' }, waist: 'Measure the waist from side to side with the garment laid flat.', hip: 'Measure the hip from side to side across the widest part.', inseam: 'Measure from the crotch seam to the hem along the inner leg.', rise: 'Measure from the crotch seam to the top of the waistband.', thigh: 'Measure the thigh from side to side, just below the crotch.' }
  };
  const sgdNorm = (t) => (t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss').replace(/\s+/g, ' ').trim();
  function sgdKey(txt, extra) {
    const n = ' ' + sgdNorm(txt) + ' ';
    for (const [k, words] of extra) if (words.some((w) => w && n.indexOf(w) > -1)) return k;
    for (const [k, words] of SGD_KEYS) if (words.some((w) => n.indexOf(w) > -1)) return k;
    return null;
  }
  function sgdExtra(str) {
    const out = [];
    (str || '').split(/[;\n]/).forEach((line) => {
      const i = line.indexOf(':'); if (i < 0) return;
      const name = sgdNorm(line.slice(0, i));
      const key = SGD_KEYS.some(([k]) => k === name) ? name : sgdKey(name, []);
      const words = line.slice(i + 1).split(',').map(sgdNorm).filter(Boolean);
      if (key && words.length) out.push([key, words]);
    });
    return out;
  }
  const SGD_FR = { '¼': 0.25, '½': 0.5, '¾': 0.75, '⅛': 0.125, '⅜': 0.375, '⅝': 0.625, '⅞': 0.875 };
  const sgdUnit = (t) => {
    const n = ' ' + sgdNorm(t).replace(/[()[\],:;]/g, ' ') + ' ';
    if (/["″]/.test(t) || /\s(inch|inches|in|pulgadas?|pulg|zoll|pouces?|polegadas?|polzades?|pollici)\s/.test(n)) return 'in';
    if (/\s(cm|cms|centimetros?|centimeters?|centimetres?|zentimeter)\s/.test(n)) return 'cm';
    return null;
  };
  const sgdUnitOnly = (t) => !!sgdUnit(t) && sgdNorm(t).replace(/[()[\]"″.]/g, '').replace(/\b(inch|inches|in|pulgadas?|pulg|zoll|pouces?|polegadas?|polzades?|pollici|cm|cms|centimetros?|centimeters?|centimetres?)\b/g, '').trim() === '';
  const sgdIsVal = (t) => /\d/.test(t) && !/[a-z]{2,}/i.test(sgdNorm(t).replace(/\b(cm|in|inch)\b/g, ''));
  /* grid of a table: rows → array of {cell, c0, span} with colspan expanded (rowspan ignored) */
  function sgdGrid(t) {
    return Array.from(t.rows).map((r) => {
      let c = 0;
      return Array.from(r.cells).map((cell) => {
        const span = +(cell.dataset.sgdCs || cell.colSpan || 1);
        if (!cell.dataset.sgdCs) cell.dataset.sgdCs = span;
        const o = { cell, c0: c, span }; c += span; return o;
      });
    });
  }
  /* analyse every table in the box once: header rows, blocks, column units, value cells */
  function sgdAnalyse(box) {
    if (box._sgd) return box._sgd;
    const tables = $$('.s848-sgx__tables table', box);
    const info = { tables: [], units: new Set() };
    tables.forEach((t) => {
      const grid = sgdGrid(t);
      const wrapUnit = (() => { const w = t.closest('[data-unit-system]'); if (!w) return null; const v = w.dataset.unitSystem; return v === 'imperial' ? 'in' : v === 'metric' ? 'cm' : null; })();
      const rows = []; let colUnit = {}; let blockUnit = wrapUnit; let lastWasVal = false;
      grid.forEach((cells, ri) => {
        const tr = t.rows[ri];
        const rest = cells.filter((o) => o.c0 > 0);
        const isVal = rest.some((o) => sgdIsVal(o.cell.dataset.sgdOrig || o.cell.textContent));
        if (!isVal) {
          if (lastWasVal) { colUnit = {}; blockUnit = wrapUnit; }
          const us = new Set();
          rest.forEach((o) => { const u = sgdUnit(o.cell.textContent); if (u) { us.add(u); for (let k = o.c0; k < o.c0 + o.span; k++) colUnit[k] = u; } });
          if (us.size === 1) blockUnit = [...us][0];
          const unitRow = rest.length > 0 && rest.every((o) => !o.cell.textContent.trim() || sgdUnitOnly(o.cell.textContent));
          rows.push({ tr, cells, header: true, unitRow, colUnit: { ...colUnit } });
        } else {
          rest.forEach((o) => { o.unit = colUnit[o.c0] || blockUnit || null; if (o.unit) info.units.add(o.unit); });
          rows.push({ tr, cells, header: false, colUnit: { ...colUnit }, blockUnit });
        }
        lastWasVal = isVal;
      });
      info.tables.push({ t, rows, wrap: t.closest('.table-responsive') || t });
    });
    info.native = info.units.has('in') && info.units.has('cm');
    box._sgd = info; return info;
  }
  function sgdConvText(txt, from, to) {
    if (from === to) return txt;
    return txt.replace(/(\d+(?:[.,]\d+)?)(\s*(?:[¼½¾⅛⅜⅝⅞]|\s\d+\/\d+))?/g, (m, n, fr) => {
      const comma = n.indexOf(',') > -1;
      let v = parseFloat(n.replace(',', '.'));
      if (fr) { const f = fr.trim(); v += SGD_FR[f] || (f.indexOf('/') > 0 ? (+f.split('/')[0] / +f.split('/')[1]) : 0); }
      v = to === 'in' ? v / 2.54 : v * 2.54;
      const s = v.toFixed(1).replace(/\.0$/, '');
      return comma ? s.replace('.', ',') : s;
    });
  }
  /* CM | INCHES: tables that already have both units → show only the chosen one; otherwise convert */
  function s848SgConvert(box, unit) {
    if (!box) return;
    box.dataset.sgUnit = unit;
    const info = sgdAnalyse(box);
    // generated tables (data-s848-conv) and page tables
    info.tables.forEach(({ t, rows, wrap }) => {
      if (t.closest('[data-unit-table]')) return;
      const inScope = t.matches('table[data-s848-conv]') || t.closest('[data-s848-conv-scope]');
      if (!inScope) return;
      if (info.native) {
        const hiddenCols = {};
        rows.forEach((r) => { if (!r.header) r.cells.forEach((o) => { if (o.c0 > 0 && o.unit && o.unit !== unit) hiddenCols[o.c0] = true; }); });
        let anyVisible = false;
        rows.forEach((r) => {
          let vis = 0;
          r.cells.forEach((o) => {
            if (o.c0 === 0) return;
            let n = 0;
            for (let k = o.c0; k < o.c0 + o.span; k++) { const u = r.header ? r.colUnit[k] : o.unit; if (!(u && u !== unit) && !(r.header && hiddenCols[k] && !u)) n++; }
            if (!r.header) n = (o.unit && o.unit !== unit) ? 0 : 1;
            o.cell.style.display = n ? '' : 'none';
            if (n && o.span > 1) o.cell.colSpan = n; else if (n) o.cell.colSpan = o.span;
            if (n) vis++;
          });
          const hideRow = !vis || (r.header && r.unitRow);
          r.tr.style.display = hideRow ? 'none' : '';
          if (!hideRow && !r.header) anyVisible = true;
        });
        wrap.style.display = anyVisible ? '' : 'none';
      } else {
        rows.forEach((r) => {
          r.cells.forEach((o) => {
            if (o.c0 === 0) return;
            const c = o.cell;
            if (r.header) {
              if (c.dataset.sgdHdr === undefined && sgdUnit(c.textContent) && !c.children.length) c.dataset.sgdHdr = c.textContent;
              if (c.dataset.sgdHdr !== undefined) {
                const src = sgdUnit(c.dataset.sgdHdr) || 'cm';
                c.textContent = src === unit ? c.dataset.sgdHdr : c.dataset.sgdHdr.replace(src === 'cm' ? /\bcm\b/i : /\b(inches|inch|in|pulgadas)\b/i, unit === 'in' ? 'inch' : 'cm');
              }
              return;
            }
            if (c.dataset.cm === undefined) {
              if (!/\d/.test(c.textContent) || c.children.length) return;
              c.dataset.cm = c.textContent;
            }
            const src = o.unit || 'cm';
            c.textContent = sgdConvText(c.dataset.cm, src, unit);
          });
        });
      }
    });
  }
  function s848SgDraw(box) {
    if (!box) return;
    const wrap = $('[data-s848-sgd]', box);
    const info = sgdAnalyse(box);
    const extra = sgdExtra(wrap ? wrap.dataset.extra : '');
    // candidates: header-row cells (excluding first column) vs first-column cells of value rows
    const head = [], first = [];
    info.tables.forEach(({ rows }) => rows.forEach((r) => {
      if (r.header) { if (!r.unitRow) r.cells.forEach((o) => { if (o.c0 > 0) head.push(o.cell); }); }
      else { const o = r.cells[0]; if (o && o.c0 === 0) first.push(o.cell); }
    }));
    const keysOf = (cells) => new Set(cells.map((c) => sgdKey((c.dataset.sgdRaw || c.textContent).replace(/\([A-Z]\)/, ''), extra)).filter(Boolean));
    const cand = keysOf(first).size > keysOf(head).size ? first : head;
    const svgHas = (k) => !wrap || !!$(`[data-measure="${k}"]`, wrap);
    const letters = {}, used = new Set(), order = [];
    cand.forEach((c) => {
      const raw = c.dataset.sgdRaw || c.textContent.trim();
      const m = raw.match(/\(([A-Z])\)/);
      const key = sgdKey(raw.replace(/\([A-Z]\)/, ''), extra);
      if (key && m && !letters[key]) { letters[key] = m[1]; used.add(m[1]); }
    });
    let li = 0;
    cand.forEach((c) => {
      const raw = c.dataset.sgdRaw || c.textContent.trim();
      c.dataset.sgdRaw = raw;
      const key = sgdKey(raw.replace(/\([A-Z]\)/, ''), extra);
      if (!key || !svgHas(key)) return;
      if (!letters[key]) { while (used.has(String.fromCharCode(65 + li))) li++; letters[key] = String.fromCharCode(65 + li); used.add(letters[key]); li++; }
      if (!order.some((x) => x.key === key)) order.push({ key, letter: letters[key], label: raw.replace(/\s*\([A-Z]\)\s*/, ' ').replace(/\(\s*(cm|inch|inches|in|pulgadas)\s*\)/ig, '').trim() });
      if (!/\([A-Z]\)/.test(raw) && !c.dataset.sgdLetter) { c.appendChild(document.createTextNode(' (' + letters[key] + ')')); c.dataset.sgdLetter = letters[key]; }
    });
    /* v3.72 – tag every table cell with its measure (header/row label + value cells) so hovering
       it highlights the matching line of the drawing; works for header-row or first-column measures */
    const drawn = new Set(order.map((x) => x.key));
    const kOf = (c) => sgdKey((c.dataset.sgdRaw || c.textContent).replace(/\([A-Z]\)/, ''), extra);
    const tag = (c, k) => { c.dataset.measureKey = k; c.dataset.measureLetter = letters[k]; };
    const byFirst = cand === first;
    info.tables.forEach(({ rows }) => {
      let hdr = [], lastVal = false;
      const colOf = (o) => hdr.filter((x) => x.c0 <= o.c0 && o.c0 < x.c0 + x.span).pop();
      rows.forEach((r) => {
        if (r.header) {
          if (lastVal) hdr = [];
          lastVal = false;
          if (byFirst) return;
          r.cells.forEach((o) => {
            if (o.c0 === 0) return;
            if (r.unitRow) { const h = colOf(o); if (h) tag(o.cell, h.k); return; }
            const k = kOf(o.cell);
            if (k && drawn.has(k)) { hdr.push({ c0: o.c0, span: o.span, k }); tag(o.cell, k); }
          });
          return;
        }
        lastVal = true;
        if (byFirst) {
          const f = r.cells[0]; const k = f && f.c0 === 0 ? kOf(f.cell) : null;
          if (k && drawn.has(k)) r.cells.forEach((o) => tag(o.cell, k));
        } else {
          r.cells.forEach((o) => { if (o.c0 === 0) return; const h = colOf(o); if (h) tag(o.cell, h.k); });
        }
      });
    });
    if (!wrap) return;
    const svg = $('svg', wrap), kind = svg ? svg.dataset.kind : 'top';
    $$('[data-measure]', wrap).forEach((g) => { g.style.display = 'none'; });
    order.forEach((it) => { const g = $(`[data-measure="${it.key}"]`, wrap); g.style.display = ''; g.dataset.measureLetter = it.letter; const tx = $('text', g); if (tx) tx.textContent = it.letter; });
    wrap.hidden = !order.length;
    const guide = $('[data-s848-autoguide]', box);
    if (guide) {
      const lang = (wrap.dataset.lang || 'es').slice(0, 2).toLowerCase();
      const dict = SGD_TXT[lang] || SGD_TXT.es;
      guide.innerHTML = '';
      order.slice().sort((a, b) => a.letter.localeCompare(b.letter)).forEach((it) => {
        let txt = dict[it.key]; if (txt && typeof txt === 'object') txt = txt[kind] || txt.top;
        const p = document.createElement('p'), st = document.createElement('strong');
        st.textContent = '(' + it.letter + ') ' + it.label + ':';
        p.appendChild(st); p.appendChild(document.createTextNode(' ' + (txt || '')));
        guide.appendChild(p);
      });
      guide.hidden = !order.length;
    }
  }
  /* hover / tap crosshair: highlight the whole row and column of the cell under the pointer */
  function sgdCross(cell) {
    const t = cell.closest('table'); const box = cell.closest('.s848-sgx--hover');
    if (!t || !box) return;
    $$('.s848-hl', box).forEach((c) => c.classList.remove('s848-hl'));
    const grid = sgdGrid(t); let pos = null;
    grid.forEach((cells) => cells.forEach((o) => { if (o.cell === cell) pos = o; }));
    if (!pos) return;
    const span = cell.colSpan || 1;
    Array.from(cell.parentElement.cells).forEach((c) => c.classList.add('s848-hl'));
    grid.forEach((cells) => cells.forEach((o) => {
      if (o.cell.style.display === 'none') return;
      if (o.c0 <= pos.c0 + span - 1 && o.c0 + o.span - 1 >= pos.c0) o.cell.classList.add('s848-hl');
    }));
  }
  document.addEventListener('pointerover', (e) => {
    const c = e.target.closest && e.target.closest('.s848-sgx--hover .s848-sgx__tables td, .s848-sgx--hover .s848-sgx__tables th');
    if (c) sgdCross(c);
  });
  document.addEventListener('pointerout', (e) => {
    const t = e.target.closest && e.target.closest('.s848-sgx--hover .s848-sgx__tables table');
    if (t && !(e.relatedTarget && t.contains(e.relatedTarget)) && e.pointerType === 'mouse') $$('.s848-hl', t).forEach((c) => c.classList.remove('s848-hl'));
  });
  /* v3.72 – hover / tap a measure cell → highlight its line (+ arrows + letter) in the drawing */
  function sgdFocus(box, key) {
    const wrap = box && $('[data-s848-sgd]', box);
    if (!wrap) return;
    $$('[data-measure].is-active', wrap).forEach((g) => g.classList.remove('is-active'));
    const gs = key ? $$(`[data-measure="${key}"]`, wrap).filter((g) => g.style.display !== 'none') : [];
    gs.forEach((g) => g.classList.add('is-active'));
    wrap.classList.toggle('s848-sgd--focus', gs.length > 0);
  }
  const sgdCell = (el) => el && el.closest && el.closest('[data-s848-units] [data-measure-key]');
  document.addEventListener('pointerover', (e) => {
    const c = sgdCell(e.target);
    if (c) sgdFocus(c.closest('[data-s848-units]'), c.dataset.measureKey);
  });
  document.addEventListener('pointerout', (e) => {
    if (e.pointerType !== 'mouse') return;
    const c = sgdCell(e.target);
    if (!c || sgdCell(e.relatedTarget)) return;
    sgdFocus(c.closest('[data-s848-units]'), null);
  });
  document.addEventListener('pointerdown', (e) => {
    if (e.pointerType === 'mouse' || sgdCell(e.target)) return;
    $$('[data-s848-sgd].s848-sgd--focus').forEach((w) => sgdFocus(w.closest('[data-s848-units]'), null));
  });
  const sgdInit = () => $$('[data-s848-units]').forEach((box) => {
    s848SgDraw(box);
    const def = box.dataset.sgUnit || box.dataset.unitDefault || 'cm';
    const b = $(`[data-s848-unit="${def}"]`, box);
    if (b) $$('[data-s848-unit]', box).forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
    s848SgConvert(box, def);
  });
  sgdInit();
  document.addEventListener('click', (e) => { if (e.target.closest('[data-s848-open="s848-size-guide"]')) sgdInit(); });
  document.addEventListener('shopify:section:load', () => sgdInit());

  /* ---------------- archive list/grid view ---------------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-s848-view]');
    if (!b) return;
    $$('.s848-archive').forEach((a) => { a.dataset.view = b.dataset.s848View; });
    $$('[data-s848-view]').forEach((x) => x.setAttribute('aria-pressed', x.dataset.s848View === b.dataset.s848View ? 'true' : 'false'));
  });

  /* ---------------- cookie banner (Shopify Customer Privacy API) ---------------- */
  const initCookies = () => {
    const box = $('#s848-cookie');
    if (!box || !window.Shopify || !Shopify.loadFeatures) return;
    Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => {
      if (err) return;
      const api = window.Shopify.customerPrivacy;
      let decided = false; try { decided = !!localStorage.getItem('s848-cookie-choice'); } catch (_) {}
      if (!Shopify.designMode && !decided && api && api.shouldShowBanner && api.shouldShowBanner()) box.classList.add('is-open');
      box.addEventListener('click', (e) => {
        const b = e.target.closest('[data-s848-consent]');
        if (!b) return;
        const yes = b.dataset.s848Consent === 'accept';
        try { localStorage.setItem('s848-cookie-choice', yes ? 'accept' : 'decline'); } catch (_) {}
        box.classList.remove('is-open');
        if (api && api.setTrackingConsent) api.setTrackingConsent({ analytics: yes, marketing: yes, preferences: yes, sale_of_data: yes }, () => {});
      });
    });
  };

  /* ---------------- newsletter popup ---------------- */
  const initPopup = () => {
    const m = $('#s848-newsletter');
    if (!m || Shopify.designMode) return;
    let seen = false; try { seen = localStorage.getItem('s848-nl-seen') === '1'; } catch (_) {}
    if (seen && !location.search.includes('customer_posted')) return;
    setTimeout(() => { m.classList.add('is-open'); try { localStorage.setItem('s848-nl-seen', '1'); } catch (_) {} }, parseInt(m.dataset.delay || '6000', 10));
    m.addEventListener('click', (e) => { if (e.target === m || e.target.closest('[data-s848-modal-close]')) m.classList.remove('is-open'); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && m.classList.contains('is-open')) m.classList.remove('is-open'); });
  };

  /* ---------------- hero videos: play only the visible one ---------------- */
  const initVideos = () => {
    $$('video[data-s848-autoplay]').forEach((v) => {
      const io = new IntersectionObserver((ents) => ents.forEach((en) => { if (en.isIntersecting && v.offsetParent !== null) v.play().catch(() => {}); else v.pause(); }), { threshold: 0.05 });
      io.observe(v);
    });
  };

  /* ---------------- v3.90 sticky heroes («Fijo»): rest while covered ----------------
     A «Fijo» hero stays stuck behind ALL the following sections until the end of <main>, so its video keeps decoding
     and its full-screen layer stays composited for the whole page. On iPhone Safari that starves tile painting: when
     scrolling back up the sections are painted late and the stuck hero shows through the not-yet-painted areas.
     While the next section fully covers the hero: pause its videos; once it is covered by more than one extra screen,
     also hide it (it cannot be seen there). Nothing visible changes. */
  const initStickyHeroes = () => {
    const items = $$('main#MainContent > .shopify-section').filter((sec) => sec.querySelector('[data-s848-sticky]')).map((sec) => {
      let next = sec.nextElementSibling;
      while (next && next.querySelector('[data-s848-sticky]')) next = next.nextElementSibling; // a run of sticky heroes: the first non-sticky section covers them all
      return { sec, next, vids: $$('video', sec), covered: false, deep: false };
    }).filter((it) => it.next);
    if (!items.length) return;
    let ticking = false;
    const update = () => {
      ticking = false;
      const vh = window.innerHeight || document.documentElement.clientHeight;
      items.forEach((it) => {
        const top = it.next.getBoundingClientRect().top;
        const covered = top <= 0;
        const deep = top < -vh;
        if (covered !== it.covered) {
          it.covered = covered;
          it.vids.forEach((v) => {
            if (covered) { if (!v.paused) { v.dataset.s848Resume = '1'; v.pause(); } }
            else if (v.dataset.s848Resume === '1' || v.autoplay) { delete v.dataset.s848Resume; if (v.offsetParent !== null) v.play().catch(() => {}); }
          });
        }
        if (deep !== it.deep) { it.deep = deep; it.sec.classList.toggle('s848-hero-rest', deep); }
      });
    };
    const schedule = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('pageshow', schedule);
    update();
  };

  const init = () => {
    initHeader(); initProductForms(); initGallery(); initScrollers(); initSliders(); initCollection();
    if (wishOn) syncHearts(); hydrateHandles(); initSwatches(); initRecent(); initSearch(); initCookies(); initPopup(); initVideos(); initStickyHeroes();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', (e) => { hydrateHandles(e.target); initScrollers(e.target); initProductForms(e.target); initSliders(); initHeader(); initVideos(); });
})();

/* v3.10 – (1) mirror the page's real heading / body fonts (incl. Custom Liquid CSS) into --s848-font-heading/--s848-font-body
           (2) theme-color meta = top browser-bar colour (the bars themselves are pure CSS since v3.11) */
(() => {
  const root = document.documentElement;
  const first = (f) => (f || '').split(',')[0].trim().replace(/["']/g, '').toLowerCase();
  const probeFonts = () => {
    if (!document.body) return;
    const box = document.createElement('div');
    box.setAttribute('aria-hidden', 'true');
    box.style.cssText = 'position:absolute!important;left:-9999px!important;top:0!important;visibility:hidden!important;pointer-events:none!important;';
    box.innerHTML = '<h2 class="h2 font-heading heading">Aa</h2><p class="font-body rte">Aa</p><span style="font-family:var(--s848-font)">Aa</span><span style="font-family:var(--heading-font-stack,var(--s848-font))">Aa</span><span style="font-family:var(--body-font-stack,var(--s848-font))">Aa</span>';
    document.body.appendChild(box);
    const [h, p, s848El, th, tb] = box.children;
    const ch = getComputedStyle(h), cp = getComputedStyle(p);
    const s848F = first(getComputedStyle(root).getPropertyValue('--s848-font')) || first(getComputedStyle(s848El).fontFamily); /* raw var: immune to *{font-family:…!important} */
    /* Our own 848.css forces everything to --s848-font; only mirror a probe when something else (Custom Liquid,
       theme typography) gives headings/body a different family – otherwise keep the theme variable fallback. */
    const set = (name, cs, themeEl) => {
      const fam = cs.fontFamily, f1 = first(fam);
      if (f1 && f1 !== s848F) {
        root.style.setProperty(name, fam);
        root.style.setProperty(name + '-weight', cs.fontWeight);
        root.style.setProperty(name + '-style', cs.fontStyle);
      } else {
        root.style.removeProperty(name); root.style.removeProperty(name + '-weight'); root.style.removeProperty(name + '-style');
      }
    };
    set('--s848-font-heading', ch, th);
    set('--s848-font-body', cp, tb);
    root.dataset.s848FontsProbed = first(ch.fontFamily) + '|' + first(cp.fontFamily);
    box.remove();
  };

  /* ---- browser bars (v3.11) ----
     Colours come from CSS (--s848-edge-top / --s848-edge-bottom on <html>, .s848-edge-top strip) so first paint is right
     without JS. JS only mirrors the top colour into <meta name="theme-color"> for browsers that still use it
     (Android Chrome, iOS ≤ 18), darkened like the overlay while a drawer is open. It never touches the html background. */
  const parse = (c) => {
    if (!c) return null;
    let m = c.match(/rgba?\(([^)]+)\)/);
    if (m) { const p = m[1].split(/[\s,\/]+/).filter(Boolean).map(Number); return { r: p[0], g: p[1], b: p[2], a: p.length > 3 ? p[3] : 1 }; }
    m = c.match(/color\(srgb\s+([^)]+)\)/);
    if (m) { const p = m[1].split(/[\s\/]+/).filter(Boolean).map(Number); return { r: p[0] * 255, g: p[1] * 255, b: p[2] * 255, a: p.length > 3 ? p[3] : 1 }; }
    return null;
  };
  const css = (o) => `rgb(${Math.round(o.r)}, ${Math.round(o.g)}, ${Math.round(o.b)})`;
  let meta = document.querySelector('meta[name="theme-color"]');
  let raf = 0, probe = null;
  const paint = () => {
    raf = 0;
    if (root.dataset.s848Bars !== 'true' || !document.body) return;
    if (!probe || !probe.isConnected) {
      probe = document.createElement('span');
      probe.setAttribute('aria-hidden', 'true');
      probe.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden;visibility:hidden;pointer-events:none;background-color:var(--s848-edge-top,var(--s848-bg,#fff))';
      document.body.appendChild(probe);
    }
    let top = parse(getComputedStyle(root).backgroundColor) || parse(getComputedStyle(probe).backgroundColor);
    if (!top) return;
    if (document.body.classList.contains('s848-lock')) {
      /* v3.54: blend with the real overlay colour (dark by default, light/blurred for the cart drawer) */
      const ovEl = document.getElementById('s848-overlay');
      const ov = (ovEl && parse(getComputedStyle(ovEl).backgroundColor)) || { r: 0, g: 0, b: 0, a: 0.35 };
      const k = ov.a;
      top = { r: top.r * (1 - k) + ov.r * k, g: top.g * (1 - k) + ov.g * k, b: top.b * (1 - k) + ov.b * k };
    }
    if (!meta) { meta = document.createElement('meta'); meta.name = 'theme-color'; document.head.appendChild(meta); }
    meta.setAttribute('content', css(top));
  };
  const schedule = () => { if (!raf) raf = requestAnimationFrame(paint); };
  const init = () => { probeFonts(); schedule(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', () => { probeFonts(); schedule(); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(probeFonts);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => setTimeout(init, 50));
  window.addEventListener('resize', schedule);
  new MutationObserver(schedule).observe(document.body || root, { attributes: true, attributeFilter: ['class'] });
  window.S848 = window.S848 || {}; window.S848.refreshBars = schedule; window.S848.probeFonts = probeFonts;
})();

/* v3.22 iOS Safari edges (same method as the reference theme): the html background is what Safari shows in the
   status-bar area and under the bottom toolbar, so it is the top colour while browsing and the footer colour near the end. */
(() => {
  const root = document.documentElement;
  if (root.dataset.s848Bars !== 'true') return;
  const meta = document.querySelector('meta[name="theme-color"]');
  let ticking = false, current = '';
  const update = () => {
    ticking = false;
    const nearBottom = window.scrollY + window.innerHeight >= root.scrollHeight - window.innerHeight * 0.5;
    root.classList.toggle('s848-at-bottom', nearBottom);
    const col = getComputedStyle(root).backgroundColor;
    if (col && col !== current) { current = col; if (window.S848 && S848.refreshBars) S848.refreshBars(); else if (meta) meta.setAttribute('content', col); }
  };
  const schedule = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
  update();
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  document.addEventListener('shopify:section:load', schedule);
})();

/* v3.12 – theme editor only: preview the mobile menu drawer ("Ver menú móvil abierto en el editor") and open it while
   the header / a drawer-related block is selected in the editor. Does nothing on the live storefront. */
(() => {
  if (!(window.Shopify && Shopify.designMode)) return;
  const S848 = window.S848 || {};
  const drawer = () => document.getElementById('s848-mobile-menu');
  const pinned = () => { const d = drawer(); return !!(d && d.dataset.s848EditorOpen === 'true'); };
  const isOpen = () => { const d = drawer(); return !!(d && d.classList.contains('is-open')); };
  const open = () => { if (drawer() && S848.open && !isOpen()) S848.open('s848-mobile-menu'); };
  const close = () => { if (isOpen() && S848.close) S848.close('s848-mobile-menu'); };
  const sync = () => { if (pinned()) open(); };
  const ours = (sectionId) => { const d = drawer(); return !!(d && d.dataset.s848EditorSection === sectionId); };
  const mobileView = () => window.innerWidth <= 1024;
  const isDrawerBlock = (blockId) => { const d = drawer(); return !!(d && (d.dataset.s848EditorBlocks || '').split(',').includes(blockId)); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setTimeout(sync, 50)); else setTimeout(sync, 50);
  /* the header section re-renders on every setting change: re-open after the new drawer has been portaled */
  document.addEventListener('shopify:section:load', (e) => { if (ours(e.detail && e.detail.sectionId)) { setTimeout(() => { if (pinned() || mobileView()) open(); else if (document.body.classList.contains('s848-lock') && !document.querySelector('.s848-drawer.is-open, .s848-modal.is-open')) S848.close(); }, 60); } });
  document.addEventListener('shopify:section:select', (e) => { if (ours(e.detail.sectionId) && (pinned() || mobileView())) open(); });
  document.addEventListener('shopify:section:deselect', (e) => { if (ours(e.detail.sectionId) && !pinned()) close(); });
  document.addEventListener('shopify:block:select', (e) => {
    if (!ours(e.detail.sectionId)) return;
    if (pinned() || isDrawerBlock(e.detail.blockId)) open();
    else if (!mobileView()) close();
  });
  document.addEventListener('shopify:block:deselect', (e) => { if (ours(e.detail.sectionId) && !pinned() && !mobileView()) close(); });
  /* v3.39 – newsletter popup preview: let «Cerrar» / «No, no quiero…» close it inside the editor too */
  document.addEventListener('click', (e) => { const m = e.target.closest('#s848-newsletter'); if (m && (e.target === m || e.target.closest('[data-s848-modal-close]'))) m.classList.remove('is-open'); });

})();

/* v3.54 theme editor only: keep the cart drawer open while its section (or one of its buttons) is selected */
(() => {
  if (!(window.Shopify && Shopify.designMode)) return;
  const ID = 's848-cart-drawer';
  const isCart = (e) => e.detail && e.detail.sectionId === '848-cart-drawer';
  const open = () => window.S848 && S848.open && S848.open(ID);
  document.addEventListener('shopify:section:select', (e) => { if (isCart(e)) open(); });
  document.addEventListener('shopify:block:select', (e) => { if (isCart(e)) open(); });
  document.addEventListener('shopify:section:load', (e) => { if (isCart(e)) setTimeout(open, 60); });
  document.addEventListener('shopify:section:deselect', (e) => { if (isCart(e) && window.S848 && S848.close) S848.close(ID); });
})();

/* ---- care icons (v3.92) ----
   Product accordions with data-s848-care-icons: every care line (paragraph, list item or <br>-separated line)
   gets an inline SVG laundry symbol picked from its text (es/en/fr/de/it/pt/ca, case/accent-insensitive).
   Negations ("no", "not", "ne pas", "nicht", "non", "não"...) give the crossed variant. Opt-in; nothing runs without the attribute. */
(() => {
  const norm = (t) => (t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss').replace(/[’`´]/g, "'").replace(/\s+/g, ' ').trim();
  const has = (t, list) => list.some((k) => (k instanceof RegExp ? k.test(t) : t.indexOf(k) > -1));
  const NEG = [/(^|[^a-z])(no|not|nunca|never|avoid|evitar|evite|sin|without|jamais|nicht|kein|keine|nie|non|mai|nao|sense|n'|ne)([^a-z]|$)/, "don't", 'dont ', 'do not', 'pas de', 'ne pas', 'evitare', 'vermeiden'];
  const W = (stem) => new RegExp('(^|[^a-z])' + stem);
  const K = {
    clean: [/(limpi|lav)[a-z]* (en|a) seco/, 'tintoreria', 'dry clean', 'dry-clean', 'dryclean', /nettoy[a-z]* a sec/, 'pressing', 'chemisch', 'trockenreinig', /(lavaggio|lavare|lavat[a-z]*|pulitura|pulire|pulito) a secco/, /(limp|lav)[a-z]* a seco/, /(net|rent)[a-z]* (en|a) sec([^a-z]|$)/],
    bleach: [W('blanque'), W('lejia'), W('cloro'), W('clor([^a-z]|$)'), 'bleach', 'chlorine', 'javel', 'chlore', W('blanchi'), 'bleich', 'chlor', 'candeggi', 'lixivi', W('branque'), 'lleixiu', W('blanquej')],
    tumble: ['secadora', /sec[a-z]* en (maquina|secadora)/, 'tumble', W('dryer'), W('drier'), 'seche-linge', 'seche linge', /(sechage|secher|seche[a-z]*) en machine/, 'tambour', 'trockner', 'tumbler', 'maschinentrock', 'trommel', 'asciugatrice', /asciuga[a-z]* in (macchina|asciugatrice)/, 'maquina de secar', /seca[a-z]* (na|a|em) maquina/, 'assecadora', /assec[a-z]* (a|en) (la )?maquina/],
    iron: [W('planch'), W('iron'), 'repass', 'bugel', W('stir(are|atura|ato|a |i |o )'), 'ferro da stiro', /pass[a-z]* (a|o) ferro/, W('engom'), W('planx')],
    wring: [W('retorc'), W('escurr'), 'wring', W('tordre'), 'essorer a la main', W('strizz'), W('torcer'), W('torc[ie]'), W('escorr'), W('recargol')],
    flat: ['en plano', 'en horizontal', 'dry flat', 'flat dry', 'lay flat', 'a plat', 'liegend', 'in piano', 'na horizontal', 'em plano', 'en pla([^a-z]|$)'].map((k) => (k.indexOf('(') > -1 ? new RegExp(k) : k)),
    line: [W('tender'), 'tendedero', W('colga'), W('cuelg'), /sec[a-z]* al aire/, 'al aire libre', 'line dry', 'hang dry', 'hang to dry', 'drip dry', 'air dry', 'suspendu', "a l'air", W('etend'), 'aufhang', 'leine', 'lufttrock', W('stend'), "all'aria", W('append'), W('estend'), W('pendur'), /seca[a-z]* ao ar/, "a l'aire", W('penj')],
    hand: ['a mano', 'hand wash', 'handwash', 'wash by hand', 'by hand', 'a la main', 'handwasch', 'von hand', 'a mao', /a ma([^a-z]|$)/],
    inside: ['al reves', 'del reves', W('reves'), 'inside out', 'inside-out', 'reverse side', "a l'envers", W('envers'), 'auf links', 'links wasch', 'linksseitig', 'linke seite', 'rovescio', 'avesso', 'del dret', 'girar la peca'],
    wash: [W('lav(ar|ad|e|er|ag|at|ab|ou|o |a )'), 'wash', 'lave-linge', 'wasch', 'wasche', W('rent(ar|at|eu|i |a |adora)')]
  };
  const LOW = ['baja', 'bajo', 'suave', 'delicad', 'low', 'gentle', 'basse', 'doux', 'niedrig', 'schon', 'bassa', 'basso', 'baixa', 'baixo', 'suau', 'max. 110', '110'];
  const MED = ['media', 'medio', 'medium', 'moyen', 'mittel', 'mitjana', '150'];
  const HIGH = ['alta', 'alto', 'high', 'haute', 'hoch', 'elevada', 'elevata', '200'];
  const tempOf = (t) => { const m = t.match(/(\d{2})\s*(?:º|°|ºc|°c|c(?![a-z])|grados|graus|graus|degrees|deg|grad|gradi|degres)/); return m ? m[1] : ''; };
  const level = (t) => (has(t, HIGH) ? 3 : has(t, MED) ? 2 : has(t, LOW) ? 1 : 0);

  /* SVG parts, 24x24, stroke = currentColor */
  const X = '<path d="M3.5 3.5l17 17M20.5 3.5l-17 17"/>';
  const dots = (n, y, cx) => { let s = ''; for (let i = 0; i < n; i++) s += '<circle cx="' + (cx - (n - 1) * 1.6 + i * 3.2) + '" cy="' + y + '" r=".85" fill="currentColor" stroke="none"/>'; return s; };
  const txt = (s, y, fs) => '<text x="12" y="' + y + '" text-anchor="middle" font-size="' + fs + '" font-family="inherit" fill="currentColor" stroke="none">' + s + '</text>';
  const TUB = '<path d="M2 6.5l2.4 13.5h15.2L22 6.5"/><path d="M2.6 9.5c1.6 1.6 3.1 1.6 4.7 0s3.1-1.6 4.7 0 3.1 1.6 4.7 0 3.1-1.6 4.7 0"/>';
  const DRAW = {
    wash: (o) => TUB + (o.temp ? txt(o.temp, 17.8, 7.5) : '') + (o.neg ? X : ''),
    hand: (o) => TUB + '<path d="M8.6 17.6v-4M10.4 17.6v-5M12.2 17.6v-5M14 17.6v-4M8.6 17.6h7.2l1.6-2.6"/>' + (o.neg ? X : ''),
    bleach: (o) => '<path d="M12 4l9 15.5H3z"/>' + (o.neg ? X : ''),
    tumble: (o) => '<rect x="3.5" y="3.5" width="17" height="17"/><circle cx="12" cy="12" r="6"/>' + (o.neg ? X : dots(o.lvl, 12, 12)),
    iron: (o) => '<path d="M2 19.5C3.2 13.4 6.4 9 10.6 9h7.6c1.9 0 3.3 1.4 3.3 3.3v7.2z"/><path d="M8.3 9c.4-2.9 1.9-4.5 4.1-4.5h6.6V9"/>' + (o.neg ? X : dots(o.lvl, 15.2, 14)),
    clean: (o) => '<circle cx="12" cy="12" r="8.5"/>' + (o.neg ? X : txt('P', 15.3, 9)),
    inside: () => '<circle cx="12" cy="12" r="8.5"/><path d="M12 10.8v5.6"/><circle cx="12" cy="8" r=".8" fill="currentColor" stroke="none"/>',
    line: (o) => '<rect x="3.5" y="3.5" width="17" height="17"/><path d="M3.5 4c3.5 4.5 13.5 4.5 17 0"/>' + (o.neg ? X : ''),
    flat: (o) => '<rect x="3.5" y="3.5" width="17" height="17"/><path d="M7 12h10"/>' + (o.neg ? X : ''),
    wring: (o) => '<path d="M3 8l4.5 4L3 16M21 8l-4.5 4 4.5 4"/><path d="M7.5 12c2.5-3.6 6.5-3.6 9 0-2.5 3.6-6.5 3.6-9 0z"/>' + (o.neg ? X : ''),
    dot: () => '<circle cx="12" cy="12" r="1.6" fill="currentColor" stroke="none"/>'
  };
  /* custom keyword codes (Spanish, as typed in the editor) */
  const CODES = { 'lavar': ['wash'], 'lavar-mano': ['hand'], 'lejia': ['bleach'], 'secadora': ['tumble'], 'secadora-baja': ['tumble', 1], 'planchar': ['iron'], 'planchar-baja': ['iron', 1], 'planchar-media': ['iron', 2], 'planchar-alta': ['iron', 3], 'limpieza-seco': ['clean'], 'seco': ['clean'], 'reves': ['inside'], 'tender': ['line'], 'secar-plano': ['flat'], 'plano': ['flat'], 'retorcer': ['wring'], 'punto': ['dot'], 'ninguno': ['none'] };
  const parseCustom = (raw) => (raw || '').split(/\n|;/).map((l) => {
    const m = l.split(/=|:|→|->/); if (m.length < 2) return null;
    let code = norm(m.pop()).replace(/\s+/g, '-'); const key = norm(m.join(':')); if (!key) return null;
    let neg = false; if (code.indexOf('no-') === 0) { neg = true; code = code.slice(3); }
    let temp = ''; const tm = code.match(/^lavar-(\d{2})$/); if (tm) { temp = tm[1]; code = 'lavar'; }
    const c = CODES[code]; return c ? { key, kind: c[0], lvl: c[1] || 0, neg, temp } : null;
  }).filter(Boolean);

  const ORDER = ['clean', 'bleach', 'tumble', 'iron', 'wring', 'flat', 'line', 'inside', 'hand', 'wash'];
  const kindOf = (t, temp) => {
    for (const k of ORDER) {
      if (!has(t, K[k])) continue;
      if (k === 'wring' && has(t, K.wash)) continue;
      if (k === 'inside' && temp) return 'wash';
      return k;
    }
    return '';
  };
  /* "no más de 30 ºC" / "not above 40°C" are limits, not negations */
  const unLimit = (t) => t.replace(/(no|not|nicht|non|nao|ne pas)( (usar|use|utiliser|usare|lavar|wash|laver|waschen))? (mas|more|mehr|piu|mais|superior|superiore|above|over|exceed|exceder|uber|oltre|depasser|plus)( de| than| di| que| a)?/g, '');
  /* "no planchar sobre el estampado" / "do not iron print": a partial restriction, the action itself is allowed */
  const PART = [W('estampa'), W('print'), W('imprim'), 'druck', W('stampa'), W('vinil'), W('vinyl'), W('serigraf'), W('logo'), W('bordad'), 'embroider', W('brod'), 'stickerei', W('transfer'), W('decorac'), W('ricam'), W('aplique'), W('applique')];
  const classify = (raw, custom) => {
    const t = norm(raw); if (!t) return null;
    for (const c of custom) if (t.indexOf(c.key) > -1) return { kind: c.kind, neg: c.neg, temp: c.temp || tempOf(t), lvl: c.lvl };
    const temp = tempOf(t); const lvl = level(t);
    /* the instruction is the first clause that names a care action; its own negation decides the cross,
       so "Planchar a baja temperatura, evitar planchar sobre estampados" stays a (low) iron */
    const clauses = t.replace(/(^|[^a-z])(max|min|aprox|approx|ca|env|temp)\./g, '$1$2').split(/\s*(?:[,;(\[]|\.(?=\s|$)|\s[-–—]\s|\s(?:pero|but|aber|however|sin embargo|cependant|pero)\s)\s*/).filter(Boolean);
    let kind = '', neg = false;
    for (const cl of clauses) {
      const k = kindOf(cl, temp);
      if (k) { kind = k; neg = has(unLimit(cl), NEG) && !has(cl, PART); break; }
    }
    if (!kind) return null;
    return { kind, neg: kind === 'inside' ? false : neg, temp, lvl };
  };
  const svg = (o) => '<span class="s848-careico s848-careico--' + o.kind + (o.neg ? ' is-no' : '') + '" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round">' + DRAW[o.kind](o) + '</svg></span>';
  const iconFor = (text, custom, fb) => { let o = classify(text, custom); if (!o) o = fb === 'dot' ? { kind: 'dot' } : null; return o && o.kind !== 'none' ? svg(o) : ''; };
  /* lines = content between block boundaries, <br> and raw newlines; Range.cloneContents keeps inline
     formatting (bold, links, wrapping spans) intact on every line, whatever wraps the text */
  const BLOCK = /^(P|DIV|LI|UL|OL|H[1-6]|TABLE|TBODY|THEAD|TR|TD|TH|SECTION|ARTICLE|BLOCKQUOTE|DL|DT|DD|PRE|HR)$/;
  const getLines = (body) => {
    const pts = [[body, 0]];
    const walk = (node) => {
      Array.from(node.childNodes).forEach((ch, i) => {
        if (ch.nodeType === 1) {
          if (ch.tagName === 'BR') { pts.push([node, i], [node, i + 1]); }
          else if (BLOCK.test(ch.tagName)) { pts.push([node, i], [ch, 0]); walk(ch); pts.push([ch, ch.childNodes.length], [node, i + 1]); }
          else if (!/^(SCRIPT|STYLE|TEMPLATE)$/.test(ch.tagName)) walk(ch);
        } else if (ch.nodeType === 3) {
          const v = ch.nodeValue; let j = v.indexOf('\n');
          while (j > -1) { pts.push([ch, j], [ch, j + 1]); j = v.indexOf('\n', j + 1); }
        }
      });
    };
    walk(body);
    pts.push([body, body.childNodes.length]);
    const out = [];
    for (let i = 0; i < pts.length - 1; i++) {
      const r = document.createRange();
      try { r.setStart(pts[i][0], pts[i][1]); r.setEnd(pts[i + 1][0], pts[i + 1][1]); } catch (e) { continue; }
      if (r.collapsed) continue;
      const frag = r.cloneContents();
      const text = (frag.textContent || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
      if (!text) continue;
      frag.querySelectorAll('br').forEach((x) => x.remove());
      Array.from(frag.querySelectorAll('*')).reverse().forEach((el) => { if (BLOCK.test(el.tagName)) el.replaceWith(...el.childNodes); });
      out.push({ text, frag });
    }
    return out;
  };

  const run = (body) => {
    if (!body || body.dataset.s848CareDone) return;
    body.dataset.s848CareDone = '1';
    const custom = parseCustom(body.getAttribute('data-s848-care-keys'));
    const fb = body.getAttribute('data-s848-care-fallback') || 'none';
    /* metaobject list (.s848-care li): icon only where the entry has no image of its own */
    if (body.querySelector('ul.s848-care')) {
      body.querySelectorAll('ul.s848-care > li').forEach((li) => { if (li.querySelector('img')) return; const ic = iconFor(li.textContent, custom, fb); if (ic) li.insertAdjacentHTML('afterbegin', ic); });
      return;
    }
    /* rich text / multi-line text: rebuilt as one vertical list, one row per line */
    const lines = getLines(body);
    if (!lines.length) return;
    const list = document.createElement('div');
    list.className = 's848-carelist';
    lines.forEach((ln) => {
      const row = document.createElement('div'); row.className = 's848-careln';
      const ic = iconFor(ln.text, custom, fb); if (ic) row.insertAdjacentHTML('afterbegin', ic);
      const tx = document.createElement('span'); tx.className = 's848-careln__txt'; tx.appendChild(ln.frag);
      row.appendChild(tx); list.appendChild(row);
    });
    body.textContent = '';
    body.appendChild(list);
    body.classList.add('s848-care-on');
  };
  const init = (scope) => (scope || document).querySelectorAll('[data-s848-care-icons]').forEach(run);
  window.S848CareIcons = { classify, init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
